import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { convertOidcUserToLoginInfo } from '../Utils/OidcAuth';
import { LoginInfo } from '../Utils/Login';
import { setCurrentUser } from '../Utils/ApiConfig';

interface AuthInitializerProps {
    setLoginInfo: (loginInfo: LoginInfo) => void;
    children: React.ReactNode;
}

export default function AuthInitializer({ setLoginInfo, children }: AuthInitializerProps) {
    const auth = useAuth();

    useEffect(() => {
        // Initialize user from OIDC context when auth state changes
        if (auth.isAuthenticated && auth.user) {
            try {
                // Set the current user in the API config for JWT token usage
                setCurrentUser(auth.user);

                // Convert OIDC user to LoginInfo format
                const loginInfo = convertOidcUserToLoginInfo(auth.user);
                setLoginInfo(loginInfo);
            } catch (error) {
                console.error('Error initializing user from OIDC context:', error);
            }
        } else if (!auth.isLoading && !auth.isAuthenticated) {
            // Clear user if not authenticated and not loading
            setCurrentUser(null);
        }
    }, [auth.isAuthenticated, auth.user, auth.isLoading, setLoginInfo]);

    return <>{children}</>;
}
